import React from 'react'
import HeroSection from './hero'
import WhySection from './why'
import SyllabusSection from './syllabus'
import LeaderMessageSection from './leaderMessage'
import AlumniSection from './alumni'
import ApplySection from './apply'

const HomePageBody = () => {
  return (
    <>
      <HeroSection />
      <WhySection />
      <SyllabusSection />
      <LeaderMessageSection />
      <AlumniSection />
      <ApplySection />
    </>
  )
}

export default HomePageBody
